<form [formGroup]="formDetails">
  <div class="d-flex gap-30">
    <div class="form-field">
      <p>User Name/Presenter ID <span class="text-red">*</span></p>
      <mat-form-field appearance="fill" class="w-295">
        <input
          matInput
          autocomplete="off"
          maxlength="255"
          formControlName="presenterId"
        />
      </mat-form-field>
      <mat-error *ngIf=""></mat-error>
      <div *ngIf="formDetails.get('presenterId')?.hasError('pattern') && formDetails.get('presenterId')?.touched && formDetails.get('presenterId')?.dirty"
        class="text-danger-300">
        User Name/Presenter ID is mandatory.
      </div>
    </div>
    <div class="form-field">
      <p>Password/Auth Code <span class="text-red">*</span></p>
      <mat-form-field appearance="fill" class="w-295">
        <input
          matInput
          autocomplete="off"
          maxlength="255"
          formControlName="authenticationCode"
        />
      </mat-form-field>
      <div *ngIf="formDetails.get('authenticationCode')?.hasError('pattern') && formDetails.get('authenticationCode')?.touched && formDetails.get('authenticationCode')?.dirty"
        class="text-danger-300">
        Password/Auth Code is mandatory.
      </div>
    </div>
  </div>
  <div class="d-flex gap-30">
    <div class="form-field">
      <p>Email</p>
      <mat-form-field appearance="fill" class="w-295">
        <input
          matInput
          autocomplete="off"
          maxlength="255"
          formControlName="email"
        />
      </mat-form-field>
      <div *ngIf="formDetails.get('email')?.hasError('pattern') && formDetails.get('email')?.touched && formDetails.get('email')?.dirty"
        class="text-danger-300">
        Email is not valid
      </div>
    </div>
    <div class="form-field">
      <p>Company Authorisation Code <span class="text-red">*</span></p>
      <mat-form-field appearance="fill" class="w-295">
        <input
          matInput
          autocomplete="off"
          maxlength="255"
          formControlName="companyAuthorisationId"
        />
      </mat-form-field>
      <div *ngIf="formDetails.get('companyAuthorisationId')?.hasError('pattern') && formDetails.get('companyAuthorisationId')?.touched && formDetails.get('companyAuthorisationId')?.dirty"
        class="text-danger-300">
        Company Authorisation Code is mandatory.
      </div>
    </div>
  </div>
</form>
